import { useMemo } from "react";
import { getUserFriendlyErrorMessage } from "@/lib/error/error-utils";
import { useUpdateNotificationPreferences, useUpdateProfile } from "./use-profile-mutation";
import { useProfileQuery } from "./use-profile-query";

export const useProfile = () => {
  const { data: user, loading, error, retry } = useProfileQuery();
  const { execute: updateProfile, isLoading: updatingProfile } = useUpdateProfile();
  const { execute: updateNotificationPreferences, isLoading: updatingNotifications } =
    useUpdateNotificationPreferences();

  const profileData = useMemo(() => {
    if (!user) return null;

    return {
      id: user.id,
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
      emailVerified: user.emailVerified,
      fullName: `${user.firstName} ${user.lastName}`,
      initials: `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`.toUpperCase(),
    };
  }, [user]);

  const errorMessage = useMemo(() => {
    if (!error) return null;
    return getUserFriendlyErrorMessage(error);
  }, [error]);

  const isLoading = loading || updatingProfile || updatingNotifications;

  return {
    profile: profileData,
    loading: isLoading,
    error,
    errorMessage,
    retry,
    updateProfile,
    updateNotificationPreferences,
    isUpdating: updatingProfile || updatingNotifications,
  };
};
